import {useEffect, useReducer, useRef} from 'react';
import classNames from 'classnames';

import Loading from '@components/Loading';
import {reducer} from '@reducers/product/list';

import {useBrand} from '../Context/Brand';

function checkedBrand(props) {
	let brand = {};
	if (props.filters.brand) {
		let r = props.filters.brand.split('|');
		for (let i = 0; i < r.length; i++) {
			brand[r[i]] = true;
		}
	}
	return brand;
}

let filterItems = null;
function Desktop(props) {
	const {styles} = props;
	const sliderRef = useRef({});
	const {brands, loading, filters, updateFilter} = useBrand();
	const [state, dispatch] = useReducer(reducer, {
		open: props.filters.brand ? true : false,
		brands,
	});

	useEffect(() => {
		dispatch({
			type: 'SET_DATA',
			data: {
				brands,
			},
		});
	}, [brands]);

	const handelCollapse = () => {
		if (state.open) {
			sliderRef.current.style.height =
				sliderRef.current.parentElement.clientHeight + 'px';
			setTimeout(() => {
				sliderRef.current.style.height = '0px';
				dispatch({
					type: 'SET_DATA',
					data: {open: !state.open},
				});
			}, 10);
		} else {
			sliderRef.current.style.height = 'auto';
			dispatch({
				type: 'SET_DATA',
				data: {open: !state.open},
			});
		}
	};

	const handleSelect = brand => {
		let isExist = filters.find(i => i._id === brand._id);
		let newFilter = [];
		if (isExist) {
			newFilter = [...filters.filter(i => i._id !== brand._id)];
		} else {
			newFilter = [...filters, {...brand, type: 'brand'}];
		}

		updateFilter(newFilter, true);
	};

	const handleSearch = event => {
		if (filterItems) clearInterval(filterItems);
		filterItems = null;
		const val = event.currentTarget.value;
		filterItems = setInterval(() => {
			dispatch({
				type: 'SET_DATA',
				data: {
					brands: state.brands.map(item => ({
						...item,
						hide: val
							? !item.value.name.toLowerCase().match(val.toLowerCase())
							: false,
					})),
				},
			});
			clearInterval(filterItems);
		}, 500);
	};

	const collapseItem = checkedBrand(props);
	return (
		<div className={`${styles.filterListCard}`}>
			<div className={`${styles.cardHeader}`}>
				<span
					className='card-link'
					data-toggle='collapse'
					aria-expanded={state.open}
					onClick={() => handelCollapse()}
				>
					Brand
				</span>
			</div>
			<div className={`collapse ${state.open && 'show'}`} ref={sliderRef}>
				<div className={styles.retailerFilter}>
					<div className={styles.searchFilter}>
						<button className={styles.srcIconFt}>
							<i className='fas fa-search'></i>
						</button>
						<input
							type='search'
							placeholder='Search'
							className={classNames(styles.formControl, 'form-control')}
							onChange={e => handleSearch(e)}
						/>
					</div>
					<div className={styles.checkList}>
						{loading ? (
							<Loading.ListItem length={3} />
						) : (
							<ul>
								{state.brands.map((item, i) => {
									return (
										!item.hide && (
											<li key={i}>
												<label className='custom-check'>
													{item.value.name}
													<input
														type='checkbox'
														checked={collapseItem[item._id] ? true : false}
														onChange={() =>
															handleSelect({
																_id: item._id,
																label: item.value.name,
															})
														}
													/>
													<span className='checkmark'></span>
												</label>
											</li>
										)
									);
								})}
							</ul>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}

function Mobile(props) {
	const {styles} = props;
	const {brands, loading} = useBrand();
	const [state, dispatch] = useReducer(reducer, {
		brands,
		collapseItem: checkedBrand({filters: props.params}),
	});

	useEffect(() => {
		dispatch({
			type: 'SET_DATA',
			data: {
				brands,
			},
		});
	}, [brands]);

	const handleSelect = brand => {
		let collapseItem = {...state.collapseItem};
		collapseItem[brand._id] = !collapseItem[brand._id];

		let newFilter = [...brands]
			.filter(i => collapseItem[i._id] === true)
			.map(item => ({_id: item._id, label: item.value.name, type: 'brand'}));

		props.setFilter(newFilter);
		dispatch({
			type: 'SET_DATA',
			data: {
				collapseItem,
			},
		});
	};

	const handleSearch = event => {
		if (filterItems) clearInterval(filterItems);
		filterItems = null;
		const val = event.currentTarget.value;
		filterItems = setInterval(() => {
			dispatch({
				type: 'SET_DATA',
				data: {
					brands: state.brands.map(item => ({
						...item,
						hide: val
							? !item.value.name.toLowerCase().match(val.toLowerCase())
							: false,
					})),
				},
			});
			clearInterval(filterItems);
		}, 500);
	};

	return (
		<div className={`${styles.filterListCard}`}>
			<div className={`collapse show`}>
				<div className={styles.retailerFilter}>
					<div className={styles.searchFilter}>
						<button className={styles.srcIconFt}>
							<i className='fas fa-search'></i>
						</button>
						<input
							type='search'
							placeholder='Search'
							className={classNames(styles.formControl, 'form-control')}
							onChange={e => handleSearch(e)}
						/>
					</div>
					<div className={styles.checkList}>
						{loading ? (
							<Loading.ListItem length={3} />
						) : (
							<ul>
								{state.brands.map((item, i) => {
									return (
										!item.hide && (
											<li key={i}>
												<label className='custom-check'>
													{item.value.name}
													<input
														type='checkbox'
														checked={
															state.collapseItem[item._id] ? true : false
														}
														onChange={() =>
															handleSelect({
																_id: item._id,
																label: item.value.name,
															})
														}
													/>
													<span className='checkmark'></span>
												</label>
											</li>
										)
									);
								})}
							</ul>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}

function Brands(props) {
	return props.isMobile ? <Mobile {...props} /> : <Desktop {...props} />;
}

export default Brands;
